import React, { useMemo } from "react";
import "./ConditionSearch.less";
import { ConditionSearchJoyItem } from "./ConditionSearchJoyItem";
import { ConditionSearchTaskItem } from "./ConditionSearchTaskItem";
import { ConditionSearchScheduleItem } from "./ConditionSearchScheduleItem";
import i18n from "@/i18n";
import { SearchType } from "@/services/SearchService";

export enum timeSlot {
  today = "1",
  tomorrow = "2",
  thisWeek = "3",
  nextWeek = "4",
  thisMonth = "5",
  nextMonth = "6"
}

export const timeList = [
  { label: i18n.t("common:Condition.today"), value: timeSlot.today },
  { label: i18n.t("common:Condition.tomorrow"), value: timeSlot.tomorrow },
  { label: i18n.t("common:Condition.this week"), value: timeSlot.thisWeek },
  { label: i18n.t("common:Condition.next week"), value: timeSlot.nextWeek },
  { label: i18n.t("common:Condition.this month"), value: timeSlot.thisMonth },
  { label: i18n.t("common:Condition.next month"), value: timeSlot.nextMonth }
];

const ConditionSearch = ({
  searchType,
  handleClose,
  setFolderIds,
  setType,
  t,
  ConditionVisible,
  setJoyTypeList,
  setTaskStatus,
  setTaskDeadlineTime,
  setScheduleDeadlineTime,
  setFileTypeList,
  setTaskPriorityType,
  setScheduleColor,
  setSearchValue
}: {
  searchType: SearchType;
  handleClose: any;
  setFolderIds: Function;
  setType: Function;
  t: any;
  setJoyTypeList: Function;
  setTaskStatus: Function;
  setTaskDeadlineTime: Function;
  setScheduleDeadlineTime: Function;
  setFileTypeList: Function;
  setTaskPriorityType: Function;
  setScheduleColor: Function;
  setSearchValue: Function;
  ConditionVisible: boolean;
}) => {
  const ConditionType = useMemo(() => {
    switch (searchType) {
      case SearchType.JoySpace:
        return (
          <ConditionSearchJoyItem
            setType={setType}
            setFolderIds={setFolderIds}
            onClose={handleClose}
            t={t}
            ConditionVisible={ConditionVisible}
            setJoyTypeList={setJoyTypeList}
            setFileTypeList={setFileTypeList}
            setSearchValue={setSearchValue}
          />
        );
      case SearchType.Task:
        return (
          <ConditionSearchTaskItem
            setTaskPriorityType={setTaskPriorityType}
            onClose={handleClose}
            t={t}
            ConditionVisible={ConditionVisible}
            setTaskStatus={setTaskStatus}
            setTaskDeadlineTime={setTaskDeadlineTime}
          />
        );
      case SearchType.Schedule:
        return (
          <ConditionSearchScheduleItem
            onClose={handleClose}
            t={t}
            ConditionVisible={ConditionVisible}
            setScheduleDeadlineTime={setScheduleDeadlineTime}
            setScheduleColor={setScheduleColor}
          />
        );
      default:
        return null;
    }
  }, [
    searchType,
    setType,
    setFolderIds,
    handleClose,
    t,
    ConditionVisible,
    setJoyTypeList,
    setFileTypeList,
    setSearchValue,
    setTaskStatus,
    setTaskDeadlineTime,
    setScheduleDeadlineTime,
    setTaskPriorityType,
    setScheduleColor
  ]);
  return <div className="condition_search">{ConditionType}</div>;
};

export default ConditionSearch;
